import moment from "moment";

export const columns = [
  {
    field: "createdAt",
    header: "Created At",
    accessor: (row) => (
      <div>
        <p>{moment(row?.createdAt).utc().format("DD MMM YYYY hh:mma")}</p>
      </div>
    ),
  },
  {
    field: "regionType",
    header: "Region Type",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "regionType")}>
          <p className="text-blue-600">{row?.regionType}</p>
        </div>
      </>
    ),
  },
  {
    field: "country",
    header: "Country",
    accessor: (row, handleCellClick) => (
      <>
        <div >
          <p>{row?.country?.name}</p>
        </div>
      </>
    ),
  },
  {
    field: "city",
    header: "City",
    accessor: (row, handleCellClick) => (
      <>
        <div >
          <p>{row?.city?.name}</p>
        </div>
      </>
    ),
  },
  {
    field: "zoneCode",
    header: "Zone Code",
    accessor: (row, handleCellClick) => (
      <>
        <div >
          <p>{row?.zoneCode}</p>
        </div>
      </>
    ),
  },
  {
    field: "additionalFee",
    header: "Additional Fee",
    accessor: (row, handleCellClick) => (
      <>
        <div >
          <p>{row?.additionalFee}</p>
        </div>
      </>
    ),
  },
  {
    field: "referralFeeRate",
    header: "Referral Fee Rate",
    accessor: (row, handleCellClick) => (
      <>
        <div >
          <p>{row?.referralFeeRate}</p>
        </div>
      </>
    ),
  },
  {
    field: "closingFeeRate",
    header: "Closing Fee Rate",
    accessor: (row, handleCellClick) => (
      <>
        <div >
          <p>{row?.closingFeeRate}</p>
        </div>
      </>
    ),
  },
  {
    field: "shippingFeeRate",
    header: "Shipping Fee Rate",
    accessor: (row, handleCellClick) => (
      <>
        <div >
          <p>{row?.shippingFeeRate}</p>
        </div>
      </>
    ),
  },
  {
    field: "shippingHandlingFeeFixedRate",
    header: "Shipping Handling Fee FixedRate",
    accessor: (row, handleCellClick) => (
      <>
        <div >
          <p>{row?.shippingHandlingFeeFixedRate}</p>
        </div>
      </>
    ),
  },
];

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};
